import { Box, Typography } from '@mui/material';
import { tokens } from '../theme';

export default function Recognition() {
  return (
    <Box component="section" sx={{ bgcolor: tokens.pine, textAlign: 'center', py: { xs: 6, md: 8.75 }, px: 3 }}>
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 2.25, textAlign: 'left', maxWidth: 640, mx: 'auto' }}>
        <Box
          sx={{
            flex: '0 0 auto',
            width: 56,
            height: 56,
            borderRadius: '50%',
            border: `1.5px solid ${tokens.ember}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: tokens.mono,
            fontSize: '0.6rem',
            letterSpacing: '0.03em',
            color: tokens.ember,
            textAlign: 'center',
            lineHeight: 1.15,
          }}
        >
          TRIPLE·E
          <br />
          2024
        </Box>
        <Typography sx={{ fontSize: '0.92rem', lineHeight: 1.55, color: tokens.paperDim }}>
          <Box component="strong" sx={{ color: tokens.paper, fontWeight: 600 }}>
            Runner-up, Impactful Research Team of the Year
          </Box>
          <br />
          2024 Asia-Pacific Triple E (ACEEU) Awards — recognizing university innovation, entrepreneurship, and
          societal impact.
        </Typography>
      </Box>
    </Box>
  );
}
